// Keep in sync with Corp::Mutations::GenerateCorporateVerificationToken and
// Corp::Mutations::ConsumeCorporateVerificationToken error codes
export const CORPORATE_VERIFICATION_ERROR_CODES = {
  INVALID_TOKEN: 'invalid_corporate_verification_token',
  WRONG_ACCOUNT: 'wrong_account_corporate_verification',
  WORK_EMAIL_PREVIOUSLY_USED: 'work_email_previously_used',
} as const;

export type CorporateVerificationErrorCode =
  (typeof CORPORATE_VERIFICATION_ERROR_CODES)[keyof typeof CORPORATE_VERIFICATION_ERROR_CODES];
